import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { SORT_DIRECTION } from '@silverfort-nodelibs/common/utils/consts';

import styles from './SortableHeader.module.css';

const SortableHeader = (props) => {
    const initialSortDirection = props.reverseIconDirection ? SORT_DIRECTION.DESC : SORT_DIRECTION.ASC;

    const [sortDirection, setSortDirection] = useState(initialSortDirection);

    const sortByHeader = () => {
        const newSortDirection = props.sorted ? sortDirection * -1 : initialSortDirection;
        setSortDirection(newSortDirection);
        props.sortByHeader(props.id, newSortDirection);
    };

    const iconDirection = props.reverseIconDirection ? sortDirection * -1 : sortDirection;

    const arrowIcon =
        props.sorted && iconDirection === SORT_DIRECTION.DESC ? (
            <i className={`${!props.sorted ? styles.sortable : ''} fa fa-angle-up`}></i>
        ) : (
            <i className={`${!props.sorted ? styles.sortable : ''} fa fa-angle-down`}></i>
        );

    return (
        <div
            title={props.title ? props.title : ''}
            onClick={() => sortByHeader()}
            className={`${props.id !== 2 ? styles.whiteRightBorder : ''}`}>
            <span>{props.header}</span>
            {props.tooltip && (
                <Tooltip
                    title={<div>{props.tooltip}</div>}
                    enterDelay={100}
                    placement={'right'}
                    classes={{ tooltip: 'moreInfoIcon-tooltip' }}>
                    <div className="moreInfoIcon"></div>
                </Tooltip>
            )}
            <span className={props.classNames}>{arrowIcon}</span>
        </div>
    );
};

export default SortableHeader;
